export default __webpack_public_path__ + "static/media/carousel-next.1e9c567a.svg";